import { useLocale } from '@/shared/composables/useLocale'

const LANDING_PATH = 'visitors'

export const useHomeUrl = () => {
  const { locale } = useLocale()
  const homeUrl = `/${locale}/${LANDING_PATH}`

  return homeUrl
}
